import React from "react";
import { useTopics } from "../../admin/Settings/Tabs/useForm/useCrudTopic";
import { ButtonDelete, ButtonEdit } from "../../shared/Button";
const columns = ["Matière", "Options", "Classes", "Actions"];

const TopicsTable = () => {
	const { data, isLoading, openModal, showModal, toggleModal, item, editModal } = useTopics();
	console.log({ data });
	return (
		<div className="table-container">
			<table className="table-custom">
				<thead className="thead">
					<tr>
						{columns?.map((column, index) => (
							<th scope="col" className="py-3 px-6" key={index}>
								{column}
							</th>
						))}
					</tr>
				</thead>
				<tbody>
					{data?.map((item, index) => (
						<tr className="bg-white border-b" key={index}>
							<td className="table-td">{item?.name}</td>
							<td></td>
							<td></td>
							{/* <td className="table-td">{item?.level}</td> */}
							<td>
								<div className="flex gap-3 px-5">
									<ButtonEdit />
									<ButtonDelete />
								</div>
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
};

export default TopicsTable;
